<div class="search-nav-container input-group col-12" [dir]="biService.getDir() ? 'rtl': 'ltr'">
    <input type="text" class="form-control search-nav" [formControl]="searchFormControl" />
    <div class="search-icon-wrapper" (click)="resetControl()">
        <img class="input-icon" [ngClass]="{'close-icon': searchFormControl.value}"
            [matTooltip]="(searchFormControl.value ? 'Cancel' : 'Search') | translate"
            [src]=" !searchFormControl.value ? 'assets/icons/search-icon-blue.svg' : 'assets/icons/cancel.svg'" />
    </div>
</div>